import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import {Provider} from "react-redux";
import store from './store';
import { AxiosSetup } from './utils/helpers/api.helpers';
import { AuthProvider } from './Context/AuthContext';
import { BrowserRouter } from 'react-router-dom'; 
AxiosSetup();
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>  
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);


